import type { LevelConfig } from '../index';

export const level7: LevelConfig = {
  id: 'level_7',
  stage: '2',
  mapId: 'map_07',
  timeLimitSec: 150,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'activate_terminals', target: 3 },
  enemies: [
    { type: 'BASIC_SCAMMER', position: { x: 350, y: 300 }, patrolPath: [{ x: 350, y: 300 }, { x: 350, y: 500 }, { x: 200, y: 500 }] },
    { type: 'BASIC_SCAMMER', position: { x: 600, y: 600 }, patrolPath: [{ x: 600, y: 600 }, { x: 600, y: 800 }, { x: 450, y: 800 }] },
    { type: 'SUPPORT_SCAMMER', position: { x: 500, y: 400 }, patrolPath: [{ x: 500, y: 400 }, { x: 500, y: 600 }] },
    { type: 'SUPPORT_SCAMMER', position: { x: 750, y: 350 }, patrolPath: [{ x: 750, y: 350 }, { x: 750, y: 550 }, { x: 600, y: 550 }] },
    { type: 'SPAMMER', position: { x: 400, y: 650 }, patrolPath: [{ x: 400, y: 650 }, { x: 400, y: 800 }, { x: 250, y: 800 }] },
    { type: 'SPAMMER', position: { x: 700, y: 500 }, patrolPath: [{ x: 700, y: 500 }, { x: 850, y: 500 }, { x: 850, y: 650 }] },
  ],
  loot: [
    ...Array.from({ length: 20 }, (_, i) => ({
      type: 'COIN' as const,
      position: { x: 180 + (i % 5) * 140, y: 220 + Math.floor(i / 5) * 140 },
      value: 10,
    })),
  ],
  startingWeapon: 'RIFLE',
  startingAmmo: 4,
  unlocks: [],
};
